import { render } from "./VkIcon.vue?vue&type=template&id=7a8517e3&scoped=true"
const script = {}

import "./VkIcon.vue?vue&type=style&index=0&id=7a8517e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8517e3"]])

export default __exports__